import { render } from "./MessageOut.vue?vue&type=template&id=2d17e6a3"
import script from "./MessageOut.vue?vue&type=script&lang=ts"
export * from "./MessageOut.vue?vue&type=script&lang=ts"
script.render = render

export default script